import React, { useContext } from 'react';
import cx from 'classnames';

import styles from './ColorScheme.module.scss';

export interface Props {
  /** The element inside of the `ColorScheme` container. */
  children?: React.ReactNode;
  /** Specify the appearance mode. */
  appearance?: 'light' | 'dark';
  /** Apply custom theme class to `ColorScheme` container. */
  theme?: Parameters<typeof cx>[0];
}

export const AppearanceContext = React.createContext<Props['appearance']>(
  'light',
);
export const ThemeContext = React.createContext<Props['theme'] | null>(null);

export const ColorScheme: React.FC<Props> = ({
  children,
  appearance = 'light',
  theme,
}) => (
  <ThemeContext.Provider value={theme}>
    <AppearanceContext.Provider value={appearance}>
      <div
        data-appearance={appearance}
        className={cx(theme, [styles[appearance]])}
      >
        {children}
      </div>
    </AppearanceContext.Provider>
  </ThemeContext.Provider>
);

/**
 * Get the current appearance value from `AppearanceContext`.
 * @example const appearance = useAppearanceContext();
 */
export const useAppearanceContext = () => useContext(AppearanceContext);

/**
 * Get the current theme value from `ThemeContext`.
 * @example const theme = useThemeContext();
 */
export const useThemeContext = () => useContext(ThemeContext);

ColorScheme.displayName = 'ColorScheme';
export default ColorScheme;
export { styles };
